import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, apiError, fmtDate } from "@/lib/api";
import { EmailBadge } from "./EmailBadge";
import { CapiBadge } from "./CapiBadge";

export const LeadsTab = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await adminApi.get("/leads");
      setLeads(data);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = async (l) => {
    try {
      await adminApi.patch(`/leads/${l.lead_id}`, { status: l.status === "traitee" ? "nouvelle" : "traitee" });
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <div className="admin-table-wrap">
      <table data-testid="leads-table" className="admin-table">
        <thead><tr><th>Date</th><th>Nom</th><th>Téléphone</th><th>E-mail</th><th>Créneau</th><th>Message</th><th>Notification</th><th>Meta (serveur)</th><th>Statut</th></tr></thead>
        <tbody>
          {leads.map((l) => (
            <tr key={l.lead_id} data-testid={`lead-row-${l.lead_id}`}>
              <td>{fmtDate(l.created_at)}</td>
              <td className="font-semibold">{l.name}</td>
              <td>{l.phone}</td>
              <td>{l.email || "—"}</td>
              <td>{l.slot}</td>
              <td className="max-w-xs text-slate-600">{l.message || "—"}</td>
              <td data-testid={`lead-emails-${l.lead_id}`}>
                <div className="flex flex-col gap-1">
                  {l.email_log.length === 0 ? "—" : l.email_log.map((m, i) => (
                    <span key={i} className="flex items-center gap-1.5 text-xs text-slate-500">
                      <EmailBadge log={m} testId={`lead-email-badge-${l.lead_id}-${i}`} />{m.to}
                    </span>
                  ))}
                </div>
              </td>
              <td><CapiBadge order={l} compact testId={`lead-capi-badge-${l.lead_id}`} /></td>
              <td>
                <button type="button" onClick={() => toggle(l)} data-testid={`lead-toggle-${l.lead_id}`}
                  className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${l.status === "traitee" ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-200" : "bg-orange-100 text-orange-800 hover:bg-orange-200"}`}>
                  {l.status === "traitee" ? "Traitée ✓" : "Marquer traitée"}
                </button>
              </td>
            </tr>
          ))}
          {!loading && leads.length === 0 && <tr><td colSpan={9} className="text-center text-slate-500 py-10">Aucune demande de rappel.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
